import { colors, spacing } from '_/space-management/constants/theme';
import { StyleSheet } from 'react-native';
import { fontFamily, fontSizes } from '_/config/theme';
const styles = StyleSheet.create({
  scene: {
    flex: 1,
  },
  tab: {
    backgroundColor: 'transparent',
    elevation: 0,
    borderBottomWidth: 2,
    borderColor: colors.white,
    paddingTop: spacing.xs,
  },
  indicator: {
    backgroundColor: colors.lightSecondary,
    height: 2,
    marginBottom: -2,
    borderRadius: 2,
  },
  label: {
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: fontFamily.bold,
    fontSize: fontSizes.md,
    textTransform: 'capitalize',
  },
});

export default styles;
